import { Grid } from "@mui/material";
import { TFunction } from "next-i18next";
import Link from "next/link";
import React, { FC } from "react";
import styles from "../../styles/pages/our-team.module.scss";
import CustomButton from "../_shared/CustomButton";

const JoinUs: FC<Props> = ({ t }) => {
  const join_us = [
    { name: t("join-us-btn-1"), url: "/careers" },
    { name: t("join-us-btn-2"), url: "/internship" },
    { name: t("join-us-btn-3"), url: "/volunteer" },
  ];

  return (
    <div className={styles.joinUs}>
      <div className={styles.joinUsContainer}>
        <h2>{t("join-us-h2")}</h2>
        <p className="description">{t("join-us-p")}</p>

        <Grid container spacing={3}>
          {join_us?.map((link) => (
            <Grid item xs={12} sm={12} md={4} key={link.name + "button"}>
              <Link href={link.url}>
                <CustomButton fullWidth>{link.name}</CustomButton>
              </Link>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

interface Props {
  t: TFunction;
}

export default JoinUs;
